import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NumericKeypad from '../components/NumericKeypad';
import ThemeToggle from '../components/ThemeToggle';
import BrandMark from '../components/BrandMark';
import { signIn } from '../auth/session';

export default function SignIn() {
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? '/';
  const [empId, setEmpId] = useState('');
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function go() {
    if (!empId.trim() || pin.length < 4) return;
    setBusy(true); setErr('');
    try {
      const r = await signIn(empId, pin);
      if (r.ok) nav(from, { replace: true });
      else { setErr(r.message); setPin(''); }
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Sign in failed. Check your connection.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app">
      <div className="spread" style={{ marginBottom: 8 }}>
        <BrandMark />
        <ThemeToggle />
      </div>
      <h1>Sign in</h1>
      <p className="muted">Employee ID and PIN. You stay signed in for the shift.</p>

      <label htmlFor="emp">Employee ID</label>
      <input id="emp" autoCapitalize="characters" autoComplete="off" placeholder="e.g. E001"
        value={empId} onChange={(e) => setEmpId(e.target.value.toUpperCase())} />

      <label style={{ marginTop: 16 }}>PIN</label>
      <NumericKeypad value={pin} onChange={setPin} maxLength={8} onSubmit={go} />

      {busy && <p className="center muted">Signing in…</p>}
      {err && <p className="error center">{err}</p>}
    </div>
  );
}
